import { render, staticRenderFns } from "./PlanAccion.vue?vue&type=template&id=4751ff92&scoped=true"
import script from "./PlanAccion.vue?vue&type=script&lang=js"
export * from "./PlanAccion.vue?vue&type=script&lang=js"
import style0 from "./PlanAccion.vue?vue&type=style&index=0&id=4751ff92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4751ff92",
  null
  
)

export default component.exports